var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrow32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.53 11.47a.75.75 0 10-1.06 1.06l2.72 2.72H9a.75.75 0 000 1.5h11.19l-2.72 2.72a.75.75 0 101.06 1.06l4-4a.747.747 0 000-1.06l-4-4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow32);
export default __webpack_public_path__ + "static/media/icon-arrow-32.bcca0cee.svg";
export { ForwardRef as ReactComponent };